export const FORCE_CHANGE_PASSWORD_TRANSLATE = {
    forceChangePassword: {
        title: "Change Password",
        subtitle: "For security reasons, you must change your password to continue",
        fields: {
            currentPassword: {
                label: "Current Password",
                placeholder: "Enter your current password",
            },
            password: {
                label: "New Password",
                placeholder: "Enter your new password",
                hint: "Password must contain special characters, uppercase, lowercase and numbers"
            },
            passwordConfirmation: {
                label: "Confirm New Password",
                placeholder: "Enter the new password confirmation",
                hint: "Password confirmation must match the new password"
            },
        },
        actions: {
            update: "Change",
            close: "Close and sign out"
        },
    }
};
